import * as React from 'react';
import { PlayerFragmentFragment } from '../generated/graphql';
import { imageSize } from '../utils/imagekit';
import { getInitials } from '../utils/getInitials';
import { PremiumSpark } from '../icons/PremiumSpark';

type AvatarSize = 'sm' | 'lg';

interface Props {
  player: Pick<PlayerFragmentFragment, 'name' | 'user'>;
  className?: string;
  size?: AvatarSize;
}

export const PlayerAvatar: React.FC<Props> = ({
  player,
  size = 'sm',
  className = '',
}) => {
  const containerClass =
    size === 'sm' ? 'w-8 h-8 text-xs' : 'w-24 h-24 text-2xl';

  const sparkClass =
    size === 'sm' ? 'w-5 h-5 -mr-1.5 -mt-1.5' : 'w-10 h-10 -mr-1.5 -mt-1.5';
  return (
    <div className={`${containerClass} relative flex-shrink-0 ${className}`}>
      <div className="w-full h-full rounded-full grid place-content-center bg-grey-800 text-white overflow-hidden">
        {player.user?.profileImage ? (
          <img
            src={imageSize(player.user.profileImage.url, 'thumb')}
            alt={player.user.profileImage.caption || player.name}
            className="object-cover"
          />
        ) : (
          getInitials(player.name)
        )}
      </div>
      {player.user?.isPremium ? (
        <PremiumSpark
          className={`${sparkClass} absolute top-0 right-0 text-amber-500 stroke-white`}
        />
      ) : null}
    </div>
  );
};
